import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, Inject, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { download, getPageSize } from 'src/app/shared/utils/calsoft-validators';
import { ROUTE_TRANSITION } from 'src/app/app.animation';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { Constant } from 'src/app/constant/constant';
import { AuditService } from 'src/app/services/audit.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
@Component({
  selector: 'calsoft-audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' }
})
export class CalsoftAuditComponent implements OnInit, OnDestroy {


  url = '';
  sanitizedUrl = '';

  data: any = [];
  type: any;
  columns: any;
  auditList: any;
  id: any;
  values: any = [];
  spinner: boolean;
  name: any;
  init: boolean = false;

  constructor(
    private dialog: MatDialog,
    private commonService: CommonService,
    private dialogRef: MatDialogRef<CalsoftAuditComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private auditService: AuditService, private router: Router
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    this.data = data;
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  tabs: any = [];
  ngOnInit() {
    this.type = this.data.type
    this.auditList = this.data.response
    this.id = this.data.id;
    this.type = this.data.type;
    this.tabs = this.data.values || [];
    this.name = this.tabs.length > 0 ? this.tabs[0]['name'] : '';
    this.init = true;
  }

  auditDownload() {
    let auditType = this.data.audType;
    let entityId = this.data.auditId;
    this.commonService.downloadaudit(auditType, entityId).subscribe(
      data => {
        download(data);

      },
    )

  }

  close() {
    this.dialog.closeAll();
  }


  onTabChange(event: any) {
    this.init = false;
    const index = event.index;
    const selectedTab = this.tabs[index];

    if (selectedTab && selectedTab.content === null && !selectedTab.loading) {
      this.spinner = true;
      // this.getAuditData(event.index);
      this.name = selectedTab['label'];
      this.init = true;
    }
  }





  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
